// takes a user object, returns a function that...
// takes an item with an `accessLevels` property
// returns true if user should see the item, false if not
const checkAccessLevel = user => item => {
  const levels = item.accessLevels

  if (window.SERVER_SIDE_RENDERING) {
    // On server, only return items that will ALWAYS be shown for any user
    return levels.loggedOut && levels.loggedIn && levels.subscribed && levels.purchased && levels.tve
  } else {
    // On client, only return items appropriate for the user
    
    if(window.settings.isMonetizationModelEnabled){
      let hasAccess = false
      const userStatus = []
      if(user){
        const purchasedItems = localStorage.getItem('purchasedItems')
        const parsedPuchasedItems = (purchasedItems && JSON.parse(purchasedItems)) || null;
        user.istveLoggedIn && userStatus.push('tve')
        user.isSubscribed && userStatus.push('subscribed')
        parsedPuchasedItems && parsedPuchasedItems.purchasedItems && parsedPuchasedItems.purchasedItems.length > 0 && userStatus.push('purchased')
        if(!userStatus.length){
          userStatus.push('loggedIn')
        }
      }else{
        userStatus.push('loggedOut')
      }
      userStatus.forEach((val, i)=>{
        if(levels[val])
          hasAccess = true
      })

      return hasAccess
    }else{
      const userStatus = user && user.isSubscribed ? 'subscribed' : user ? 'loggedIn' : 'loggedOut'
      return levels && levels[userStatus]
    }
  }
}

export default checkAccessLevel
